export const MOVE_TO_BATCH_MODAL_OPENED = 'MOVE_TO_BATCH_MODAL_OPENED';
export const moveToBatchModalOpened = (moveToBatchModalId) => ({
  type: MOVE_TO_BATCH_MODAL_OPENED,
  moveToBatchModalId,
});

export const GET_FILTERED_BATCH_SHIPMENTS_SUCCESS = 'GET_FILTERED_BATCH_SHIPMENTS_SUCCESS';
export const getFilteredBatchShipmentsSuccess = (appliedFilters) => ({
  type: GET_FILTERED_BATCH_SHIPMENTS_SUCCESS,
  appliedFilters,
});

export const GET_BATCH_DETAILS_REQUEST = 'GET_BATCH_DETAILS_REQUEST';
export const getBatchDetails = (fulfillmentPlanSetId) => ({
  type: GET_BATCH_DETAILS_REQUEST,
  fulfillmentPlanSetId,
});

export const BATCH_DETAILS_RELOAD = 'BATCH_DETAILS_RELOAD';
export const reloadBatchDetails = () => ({
  type: BATCH_DETAILS_RELOAD,
});

export const GET_BATCH_DETAILS_SUCCESS = 'GET_BATCH_DETAILS_SUCCESS';
export const getBatchDetailsSuccess = (batch, appliedFilters) => ({
  type: GET_BATCH_DETAILS_SUCCESS,
  batch,
  appliedFilters,
});

export const BATCH_DETAILS_SET_IS_LOADING = 'BATCH_DETAILS_SET_IS_LOADING';
export const setIsLoading = (isLoading) => ({
  type: BATCH_DETAILS_SET_IS_LOADING,
  isLoading,
});

export const BATCH_DETAILS_GET_ORDERS_SHIPMENTS_MODE = 'BATCH_DETAILS_GET_ORDERS_SHIPMENTS_MODE';
export const getBatchDetailsOrdersShipmentsMode = (fulfillmentPlanSetId, appliedFilters) => ({
  type: BATCH_DETAILS_GET_ORDERS_SHIPMENTS_MODE,
  fulfillmentPlanSetId,
  appliedFilters,
});

export const REMOVE_FULFILLMENT_PLANS_FROM_BATCH = 'REMOVE_FULFILLMENT_PLANS_FROM_BATCH';
export const removeFulfillmentPlansFromBatch = ({ fulfillmentPlanSetId, fulfillmentPlanIds }) => ({
  type: REMOVE_FULFILLMENT_PLANS_FROM_BATCH,
  fulfillmentPlanSetId,
  fulfillmentPlanIds,
});

export const REMOVE_FULFILLMENT_PLANS_FROM_BATCH_SUCCESS = 'REMOVE_FULFILLMENT_PLANS_FROM_BATCH_SUCCESS';
export const removedFulfillmentPlansFromBatchSuccess = (fulfillmentPlanSetId) => ({
  type: REMOVE_FULFILLMENT_PLANS_FROM_BATCH_SUCCESS,
  fulfillmentPlanSetId,
});

export const VALIDATE_BATCH_ADDRESSES_REQUEST = 'VALIDATE_BATCH_ADDRESSES_REQUEST';
export const validateBatchAddresses = (processFulfillmentPlanSet, fulfillmentPlanSetId, fulfillmentPlanIds) => ({
  type: VALIDATE_BATCH_ADDRESSES_REQUEST,
  processFulfillmentPlanSet,
  fulfillmentPlanSetId,
  fulfillmentPlanIds,
});

export const VALIDATE_BATCH_ADDRESSES_SUCCESS = 'VALIDATE_BATCH_ADDRESSES_SUCCESS';
export const validateBatchAddressesSuccess = (batchData) => ({
  type: VALIDATE_BATCH_ADDRESSES_SUCCESS,
  batchData,
});

export const VALIDATE_BATCH_ADDRESSES_FAILURE = 'VALIDATE_BATCH_ADDRESSES_FAILURE';
export const validateBatchAddressesFailure = (error) => ({
  type: VALIDATE_BATCH_ADDRESSES_FAILURE,
  error,
});

export const VALIDATE_BATCH_ADDRESSES_RESULTS = 'VALIDATE_BATCH_ADDRESSES_RESULTS';
export const addressesUpdatedResponse = (data) => ({
  type: VALIDATE_BATCH_ADDRESSES_RESULTS,
  data,
});

export const BATCH_ADDRESS_VALIDATION_COMPLETED = 'BATCH_ADDRESS_VALIDATION_COMPLETED';
export const triggerBatchAddressValidationCompleted = () => ({
  type: BATCH_ADDRESS_VALIDATION_COMPLETED,
});

export const RATES_UPDATED_RESULTS = 'RATES_UPDATED_RESULTS';
export const ratesUpdatedResponse = (data) => ({
  type: RATES_UPDATED_RESULTS,
  data,
});

export const RATE_BATCH_COMPLETED = 'RATE_BATCH_COMPLETED';
export const triggerRateBatchCompleted = () => ({
  type: RATE_BATCH_COMPLETED,
});

export const SEND_SHIPMENT_NOTIFICATIONS = 'SEND_SHIPMENT_NOTIFICATIONS';
export const sendShipmentNotifications = (fulfillmentPlanSetId, fulfillmentPlanIds) => ({
  type: SEND_SHIPMENT_NOTIFICATIONS,
  fulfillmentPlanSetId,
  fulfillmentPlanIds,
});

export const SEND_SHIPMENT_NOTIFICATIONS_SUCCESS = 'SEND_SHIPMENT_NOTIFICATIONS_SUCCESS';
export const sendShipmentNotificationsSuccess = (jobGuids) => ({
  type: SEND_SHIPMENT_NOTIFICATIONS_SUCCESS,
  jobGuids,
});

export const SHIPMENT_NOTIFICATION_MESSAGE = 'SHIP_NOTIFICATION_MESSAGE';
export const shipmentNotificationMessage = (jobGuid, message) => ({
  type: SHIPMENT_NOTIFICATION_MESSAGE,
  jobGuid,
  message,
});

export const SHIPMENT_NOTIFICATIONS_SENT_SUCCESS = 'SHIPMENT_NOTIFICATIONS_SENT_SUCCESS';
export const shipmentNotificationsSentSuccessfully = (jobGuid) => ({
  type: SHIPMENT_NOTIFICATIONS_SENT_SUCCESS,
  jobGuid,
});

export const SHIPMENT_NOTIFICATIONS_SENT_FAILURE = 'SHIPMENT_NOTIFICATIONS_SENT_FAILURE';
export const shipmentNotificationsSentFailure = (jobGuid, errorMessage) => ({
  type: SHIPMENT_NOTIFICATIONS_SENT_FAILURE,
  jobGuid,
  errorMessage,
});

export const EMPTY_BATCH_DETAILS = 'EMPTY_BATCH_DETAILS';
export const emptyBatchDetails = () => ({
  type: EMPTY_BATCH_DETAILS,
});
